module.exports = __webpack_public_path__ + "static/media/icon-linkedin.2c823813.svg";